var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8675,6.2411544 L13.7718272,0.336827202 C14.2209301,-0.112275734 14.9490699,-0.112275734 15.3981728,0.336827202 C15.8472757,0.785930137 15.8472757,1.51406986 15.3981728,1.9631728 L9.4938456,7.8675 L15.3981728,13.7718272 C15.8472757,14.2209301 15.8472757,14.9490699 15.3981728,15.3981728 C14.9490699,15.8472757 14.2209301,15.8472757 13.7718272,15.3981728 L7.8675,9.4938456 L1.9631728,15.3981728 C1.51406986,15.8472757 0.785930137,15.8472757 0.336827202,15.3981728 C-0.112275734,14.9490699 -0.112275734,14.2209301 0.336827202,13.7718272 L6.2411544,7.8675 L0.336827202,1.9631728 C-0.112275734,1.51406986 -0.112275734,0.785930137 0.336827202,0.336827202 C0.785930137,-0.112275734 1.51406986,-0.112275734 1.9631728,0.336827202 L7.8675,6.2411544 Z",
    id: "ic_close",
    fill: "#04334E",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.4da771d9c23f72fca8d47a877c5bb8ee.svg";
export { ForwardRef as ReactComponent };